'use strict'

define [], () ->
  ($rootScope, $scope, $http, RentappService, RENTAPPLICATION_API_URL, $uibModalInstance) ->
    $scope.is_loading = false
    $scope.first_name = ""
    $scope.last_name = ""
    $scope.error_message = ""
   
    $scope.link_plaid_account = () ->
      if !$scope.first_name or !$scope.last_name
        $scope.error_message = "First name and last name is required."
        return
      $http.post("#{RENTAPPLICATION_API_URL}/api/v3/referrers/plaid_link_token/")
      .then (resp) ->
        $uibModalInstance.close({
          first_name: $scope.first_name,
          last_name: $scope.last_name,
          link_token: resp.data.link_token
        })
      .catch (err) ->
        console.log(err)
      
      


// WEBPACK FOOTER //
// ./components/dashboard/referral/modals/plaid_link.coffee